/**
 * Det trackeren og dashboardet deler om heatmap'et: query-parameteren der åbner en side i heatmap-tilstand, pakken
 * trackeren sender pr. sidevisning, og beskederne mellem dashboardet (Admin/Scripts/heatmap.ts) og siden i dets
 * iframe (heatmap-overlay.ts). Serverens modstykker er HeatmapPayload, AnalyticsMiddleware.HeatmapModeParameter og
 * HeatmapData.
 */

export const heatmapModeParameter = 'swp-heatmap';

/** Et klik: det klikkede elements DOM-sti, stedet i elementet som brøk 0–1 og dokumentkoordinaterne. */
export interface HeatmapClick {
    t: string;
    fx: number;
    fy: number;
    x: number;
    y: number;
}

/** Det trackeren sender til /api/analytics/heatmap; id'et er sidevisningens, så flere pakker lægges sammen. */
export interface HeatmapPayload {
    id: string;
    path: string;
    viewportWidth: number;
    viewportHeight: number;
    pageHeight: number;
    maxScroll: number;
    clicks: HeatmapClick[];
}

/** Et klik som dashboardet sender ind, med viewport-bredden det blev lavet i (w). */
export interface HeatmapDataClick extends HeatmapClick {
    w: number;
}

/** Siden er klar til data (overlay → dashboard). */
export interface HeatmapReadyMessage {
    type: 'swp-heatmap-ready';
}

/** Klik og hver sidevisnings scroll-dybde som brøk af siden (dashboard → overlay). */
export interface HeatmapDataMessage {
    type: 'swp-heatmap-data';
    clicks: HeatmapDataClick[];
    scrollDepths: number[];
}

/** Hvor mange klik der blev placeret på deres element, og hvor mange efter x/y (overlay → dashboard). */
export interface HeatmapDrawnMessage {
    type: 'swp-heatmap-drawn';
    placed: number;
    total: number;
}

export type HeatmapMessage = HeatmapReadyMessage | HeatmapDataMessage | HeatmapDrawnMessage;
